// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1UiiA","sendOtp":"AuthorizeToLogin_sendOtp__2Rt0I"};